const EMCEE_CONNECT_VARIANT = 'CONNECT';
const EMCEE_NATIVE_VARIANT = 'NATIVE';
export const EmceeVariant = Object.freeze({
  Connect: EMCEE_CONNECT_VARIANT,
  Native: EMCEE_NATIVE_VARIANT
});